/**
 * Local storage key the theme is saved to.
 */
export const LOCAL_STORAGE_THEME_KEY = 'THEME';
